// extracted by mini-css-extract-plugin
module.exports = {"container":"HeaderSticky_container__wjoiD","icon":"HeaderSticky_icon__Q5huy"};